export default __webpack_public_path__ + "static/Corrupted_video_file_01-bb4adfc691552e0592f8bad624a3b21d.png";